<template>
  <div>
    <!-- Page title -->
    <page-title
      icon="fas fa-table"
      main="Cadastro"
      sub="Carteira de Clientes"
      :help="true"
      titleHelp="Ajuda - Carteira de Clientes"
      content="Responsável por filtrar as consultas relacionadas a Carteira de Clientes desde sua criação/atualização."
    >
      <base-button
        slot="actions"
        @click="addRegion"
        type="neutral"
        class="ml-3"
        size="sm"
        v-if="$can('index', 'user')"
        >Cadastro de Carteira</base-button
      >
    </page-title>

    <!-- Modals -->
    <modal :show.sync="updateRegionClientsModal" size="lg" @close="closeModal()">
      <div slot="header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ isCreating ? "Cadastro" : "Edição" }} de Carteira
        </h5>
        <span>{{
          filter && filter.anosafra && filter.anosafra.descricao
        }}</span>
      </div>
      <br>  
      <div class="row">
        <div class="col-md-12">
          <anosafra-multiselect
            v-model="filter.anosafra"
            label="Ano Safra"
            @input="selectAnosafraRegion"
          />
        </div>
        <div class="col-md-6">
          <label class="form-control-label">{{ isCreating ? "" : "Nome da " }} Carteira</label>
          <multiselect
            v-if="isCreating"
            v-model="formRegion"
            :options="formattedRegions"
            placeholder="Selecionar Carteira"
            label="regionName"
            track-by="id"
          />
          <base-input
            v-else
            :required="true"
            class="mb-3"
            :value="nameInputValue"
            @input="nameInputValue = $event"
            placeholder="Nome da Região"
            field="node da região"
          ></base-input>
        </div>
        <div class="col-md-6">
          <label class="form-control-label">Vendedor</label>
          <multiselect
            v-model="formSalesman"
            :loading="loadingFormSalesman"
            :options="filter.salesmans"
            :allowEmpty="false"
            placeholder="Selecionar Vendedor"
            label="name"
            track-by="id"
            @search-change="findSalesmans"
          ></multiselect>
        </div>
      </div>
      <br>
      <div class="col-md-12">
        <label class="form-control-label">Clientes vinculados do erp</label>
        <div class="client-list">
          <div v-if="!findSalesmanClients" class="text-center client-height">
            <div>Não possui carteira de clientes vinculados do erp</div>
          </div>
          <div v-else>
            <div v-for="client in findSalesmanClients" :key="client.cliente" class="client-list-item">
              {{ client.client_name == null ? "Nome em Branco" : client.client_name }}
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="closeModal()">Fechar</base-button>
        <el-tooltip :disabled="!disabledSave" placement="left">
          <template #content>
            {{ tooltipMessage }}
          </template>
          
          <base-button 
            type="primary" 
            :disabled="disabledSave" 
            class="ml-2"
            @click="saveRegionClients()">
            Salvar
          </base-button>
        </el-tooltip>
      </template>
    </modal>
    <modal :show.sync="openInactivate">
      <div class="text-left justify-content-start mb--3 mt-2">
        <span class="h2">
          Tem certeza que deseja inativar essa carteira de cliente no ano safra vigente?
        </span>
      </div>
     
      <template slot="footer">
        <div>
          <button
            style="width: 7rem;"
            type="button"
            class="btn btn-warning"
            @click="openInactivate = false"
          >
            Cancelar
          </button>
          <button
            style="width: 7rem;"
            type="submit"
            class="btn btn-primary new-event--add ml-2"
            @click="updateRegionActiveValue(false)"
          >
            Continuar
          </button>
        </div>
      </template>
    </modal>
    <!-- Filters -->
    <card>
      <div slot="header" class="row align-items-center">
        <div class="col">
          <h5 class="h3 mb-0">Filtros</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-1">
            Configure quais dados deverão ser listados:
          </h6>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <anosafra-multiselect
            v-model="filter.anosafra"
            label="Ano Safra"
          />
        </div>
        <div class="col-md-2">
          <label class="form-control-label">Gerentes Comerciais</label>
          <!-- TODO: Identificar quem é admin e  -->
          <multiselect
            v-model="filter.manager"
            :options="filter.managers"
            placeholder="Escolha um Gerente Comercial"
            label="name"
            track-by="id"
            :loading="filter.isLoadingManagers"
            :disabled="!currentUser.is_admin"
            @search-change="debouncedFindManagers"
          />
        </div>
        <div class="col-md-4">
          <label class="form-control-label">Status</label>
          <multiselect
            placeholder="Escolha um Status"
            v-model="filter.status"
            :options="filter.statuses"
            @search-change="loadRegions"
            label="name"
            track-by="value"
          />
        </div>
        <div class="col-md-6">
          <label class="form-control-label">Vendedor</label>
          <multiselect
            v-model="filter.salesman"
            :options="filter.salesmans"
            :loading="filter.isLoadingSalesman"
            :disabled="
              !(
                currentUser.is_admin ||
                currentUser.is_manager ||
                currentUser.has_coordinateds
              )
            "
            @input="findClients('')"
            @search-change="findSalesmans"
            placeholder="Escolha um vendedor"
            label="name"
            track-by="id"
          ></multiselect>
        </div>
        <div class="col-md-6">
          <label class="form-control-label">Escolha um Cliente</label>
          <multiselect
            placeholder="Escolha um Cliente"
            v-model="filter.client"
            :options="filter.clients"
            :loading="filter.isLoadingClients"
            @search-change="findClients"
            label="name"
            track-by="id"
          />
        </div>
      </div>

      <div slot="footer" class="row justify-content-end" style="gap: 8px;">
        <base-button
          color="green"
          type="neutral"
          @click="clearFilters">
           Limpar Filtros
        </base-button>
        <base-button type="primary" @click="filterIsWithoutSafra()">
          <i class="fas fa-filter"></i> Filtrar
        </base-button>
      </div>
    </card>

    <!-- Table -->

    <card>
      <div v-loading="isLoadingClients">
        <div v-for="client in sortedClientsBySeller" :key="client.region_id">
          <br /><br /><br />
          <h4>
            <div class="row">
              <div class="col-12">
                <div class="d-flex align-items-center">
                  <div class="mr-5">
                    Carteira: {{ getRegionName(client) }}
                  </div>
                  <div>
                    Total de Clientes: {{ client.clients_count }}
                  </div>
                </div>
              </div>
            </div>
            <el-dropdown class="float-right" trigger="hover">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                slot="dropdown"
                class="dropdown-menu dropdown-menu-arrow show"
              >
                <a
                  class="dropdown-item"
                  @click="updateRegionClients(client.clients, client.region)"
                  >Editar Carteira</a
                >
                <a v-if="currentUser.is_admin && client.region.active === true"
                  class="dropdown-item"
                  @click="openInactivateModal(client.region)"
                  >Inativar Carteira</a
                >
                <a v-if="currentUser.is_admin && client.region.active === false"
                  class="dropdown-item"
                  @click="updateRegionActiveValue(true, client.region.id)"
                  >Reativar Carteira</a
                >
              </el-dropdown-menu>
            </el-dropdown>
          </h4>
          <h5 v-if="client.region && client.region.user">
            Vendedor: {{ client.region.user.name }}
          </h5>
          <br />
          <div style="width: 100%; overflow-x: hidden;">
            <el-table
              :data="client.clients"
              :default-sort="{ prop: 'razao_social' }"
              style="width: 100%; min-width: 850px;"
            >
              <el-table-column
                type="index"
                label=""
                width="50"
                :index="(index) => index + 1"
              ></el-table-column>

              <el-table-column
                label="Razão  social"
                min-width="200px"
                prop="razao_social"
                sortable
              ></el-table-column>
              <el-table-column
                label="Código erp"
                min-width="120px"
                prop="code"
                sortable
                class-name="left-padding-column"
              ></el-table-column>
              <el-table-column
                label="Endereço"
                min-width="180px"
                prop="endereco"
                sortable
              ></el-table-column>
              <el-table-column
                label="Bairro"
                min-width="120px"
                prop="bairro"
                sortable
              ></el-table-column>
              <el-table-column
                label="Municipio"
                min-width="120px"
                prop="municipio"
                sortable
              ></el-table-column>
              <el-table-column
                label="UF"
                min-width="80px"
                prop="uf"
                sortable
              ></el-table-column>
              <el-table-column label="Ações" min-width="50px" v-slot="{ row }">
                <el-dropdown
                  trigger="hover"
                  class="dropdown"
                  style="cursor: pointer;"
                >
                  <span class="btn btn-sm btn-icon-only text-success">
                    <i class="fas fa-ellipsis-v mt-2"></i>
                  </span>
                  <el-dropdown-menu
                    class="dropdown-menu dropdown-menu-arrow show"
                    slot="dropdown"
                  >
                    <a class="dropdown-item" href="#" @click="editClient(row)"
                      >Complementar Dados</a
                    >
                    <!-- <a class="dropdown-item" href="#" @click="changeRegion(row)">
                      Mudar Carteira
                    </a> -->
                    <div v-if="`${String(row.cpf).length}` <= 15">
                      <router-link
                        class="dropdown-item"
                        :to="{
                          name: 'Ficha Cadastral PF',
                          params: { client: row, region: client.region },
                        }"
                        >Ficha Cadastral
                      </router-link>
                    </div>
                    <div v-else>
                      <router-link
                        class="dropdown-item"
                        :to="{
                          name: 'Ficha Cadastral PJ',
                          params: { client: row, region: client.region },
                        }"
                        >Ficha Jurídica
                      </router-link>
                    </div>
                    <router-link
                      class="dropdown-item"
                      :to="{ name: 'Culturas', params: { client: row } }"
                      >Culturas</router-link
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div slot="footer" class="py-4 d-flex justify-content-end">
          <base-pagination
            v-on:input="loadFilteredClients"
            v-model="paginated_data['current']"
            :total="paginated_data['count']"
            :perPage="paginated_data['per_page']"
          ></base-pagination>
        </div>
      </div>
    </card>

    <!-- Client Edition Modal -->
    <modal @close="resetClientForm" :show.sync="clientFormModal">
      <template slot="header">
        <div>
          <h5 class="modal-title">Complemento dos dados do cliente</h5>
        </div>
      </template>
      <client-form
        ref="clientForm"
        :client="formClient"
        :culture-id-attributes="cultureIdAttributes"
        :client_properties="client_properties"
        :valid.sync="isValid"
        @remove:culture="removeCulture"
      />
      <template slot="footer">
        <base-button type="secondary" @click="clientFormModal = false">Fechar</base-button>
        <el-tooltip content="Preencha campo obrigatório" placement="top" v-if="!isValid">
          <base-button type="success" :disabled="!isValid" @click="save">Salvar</base-button>
        </el-tooltip>
        <base-button v-else type="success" :disabled="!isValid" @click="save">
          Salvar
        </base-button>
      </template>
    </modal>
 
    <!-- Change Region Modal -->
    <modal :show.sync="changeRegionModal">
      <template slot="header">
        <div>
          <h5 class="modal-title">Mudar Carteira de Cliente</h5>
        </div>
      </template>
      <form role="form">
        <div class="row justify-content-md-center">
          <div class="col-12">
            <label class="form-control-label">Selecionar a carteira</label>
            <multiselect
              style="min-height: 10rem !important;"
              v-model="formClient.region"
              :options="regions"
              label="name"
              track-by="id"
              placeholder="Selecione uma opção"
              :allow-empty="false"
              :preserveSearch="true"
            />
          </div>
        </div>
      </form>
      <template slot="footer">
        <base-button type="secondary" @click="changeRegionModal = false"
          >Fechar</base-button
        >
        <base-button type="success" @click="saveRegion">Salvar</base-button>
      </template>
    </modal>
    <go-back-modal :title="goBackModalTitle" :open="openGoBackModal" />
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Tooltip,
  Option,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from '@/components/Multiselect/anosafra_multiselect.vue';
import ClientForm from "@/views/clients/ClientForm.vue";
import swal from "sweetalert2";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { mapState, mapActions } from 'vuex';
import GoBackModal from "@/components/GoBackModal.vue";


extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    [Option.name]: Option,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    ClientForm,
    GoBackModal,
  },
  data() {
    return {
      goBackModalTitle: "Carteira removida ou não associada a um vendedor!",
      openGoBackModal: false,
      cultureIdAttributes: [],
      active: true,
      isValid: true,
      selectedAnosafraRegion: null,
      regionName: '',
      currentUser: {},
      openInactivate: false,
      filter: {
        manager: {},
        managers: [],
        anosafra: {},
        anosafras: [],
        salesman: {},
        salesmans: [],
        status: {},
        statuses:[
          {name: "ativo" ,value: true},
          {name: "inativo" ,value: false}
        ],
        client: {},
        clients: [],
        clientQuery: "",
        isLoadingClients: false,
        isLoadingSalesman: false,
        isLoadingManagers: false,
      },
      paginated_data: {
        current: 1,
        count: 10,
        per_page: 10,
      },
      clients: [],
      isLoadingClients: false,
      clientFormModal: false,
      changeRegionModal: false,
      updateRegionClientsModal: false,
      formClient: {},
      client_properties:[],
      queryClients: [],
      regionClients: [],
      formRegion: {},
      formSalesman: {},
      loadingFormSalesman: false,
      loadingRegionClients: false,
      isCreating: false,
      regions: [],
      sectors: [],
      clientSearchTimeout: null,
      leftSearch: "",
      prevAnosafra: false,
      clientPaginatedData: {},
      findManagersTimeout: null,
      findSalesmanClients: null,
      originalClient: null
    };
  },
  methods: {
    ...mapActions(['resetNotificationAction']),
    clearFilters(){
      this.filter.salesman = null
      this.filter.client = null
      this.filter.manager = null
      this.filter.anosafra = {}
      this.filter.status = null
    },
    editClient(client) {
      this.clientFormModal = true;
      this.originalClient = { ...client };
      this.formClient = { ...client }
      this.formClient.lastCultureIds = client.culture_ids
      this.formClient.culture_ids_attributes = []
      this.formClient.culture_ids = this.formClient.culture_ids.map((culture) => {
        return {
          id: culture.id,
          description: culture.culture_name,
          area: culture.culture_area,
          client_property_id: culture.client_property_id,
          culture_id: culture.culture_id 
        }
      })
    },
    closeModal() {
      this.updateRegionClientsModal = false;
      this.findSalesmanClients = null;
      this.loadFilteredClients();
    },
    changeRegion(client) {
      this.changeRegionModal = true;
      this.formClient = client;
    },
    async save() {
      if(this.formClient.client_properties.id) {
        this.formClient.client_property_id = this.formClient.client_properties.id;
      }

      if (this.formClient.financial_classifications.length == 0) {
        this.$toasted.global.defaultError({ msg: 'Campo não pode ficar em branco' });
        return;
      }

      const newClassifications = this.formClient.financial_classifications.filter(el => el.id === 'new');
      
      try {
        if (newClassifications.length > 0) {
          const createdClassifications = await Promise.all(
            newClassifications.map(async (classification) => {
              const response = await this.$http.secured.post('/api/v1/financial_classifications', {
                description: classification.description
              });

              return response.data;
            })
          );

          createdClassifications.forEach(newClassification => {
            this.formClient.financial_classifications.push({
              id: newClassification.id,
              description: newClassification.description
            });
          });

          this.formClient.financial_classifications = this.formClient.financial_classifications.filter(el => el.id !== 'new');
        }

        this.formatClientProperties();

        await this.$http.secured.patch(
          `/api/v1/clients/${this.formClient.id}`,
          {
            cliente: {
              financial_classification_ids: this.formClient.financial_classifications.map(el => el.id),
              financial_classification_attributes: newClassifications.length > 0 
                ? newClassifications.map(({ id, ...rest }) => rest) 
                : [],
              ...this.formClient
            },
            anosafra: this.filter.anosafra,
          }
        );
        this.$toasted.global.defaultSuccess();
        this.clientFormModal = false;
        this.loadFilteredClients();
        this.$refs.clientForm.moveNewClassification()
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          Object.values(error.response.data.errors).forEach((error_message) => {
            this.$toasted.global.defaultError({ msg: error_message });
          });
        } else {
          this.$toasted.global.defaultError({ msg: ' Ocorreu um erro inesperado' });
        }
      }
    },
    resetClientForm() {
      this.formClient = { ...this.originalClient };
      this.clientFormModal = false;
    },
    openInactivateModal(region) {
      this.regionId = region.id;
      this.openInactivate = true;
    },
    updateRegionActiveValue(activeValue, regionId = null) {
      if (regionId) {
        this.regionId = regionId;
      }
      this.updateActiveRegion(activeValue);
      this.loadFilteredClients();
    },
    async updateActiveRegion(activeValue) {
      try {
        const response = await this.$http.secured.put(`/api/v1/regions/${this.regionId}`, {
          anosafra_id: this.filter.anosafra.id,
          region: {
            active: activeValue
          }
        });
        if (activeValue) {
          this.$toasted.global.defaultSuccess({ msg: "Carteira reativada com sucesso!" });
        } else {
          this.$toasted.global.defaultSuccess({ msg: "Carteira inativada com sucesso!" });
        }
        console.log('[Clients][updateActiveRegion]:', response.data);

      } catch (error) {
        if (activeValue) {
          this.$toasted.global.defaultError({ msg: 'Erro ao reativar carteira' });
        } else {
          this.$toasted.global.defaultError({ msg: 'Erro ao inativar carteira' });
        }
        console.error('[Error][updateActiveRegion]:', error);

      } finally {
        this.openInactivate = false;
      }
    },
    async saveRegion() {
      const data = {
        id: this.formClient.id,
        region: this.formClient.region,
      };

      try {
        await this.$http.secured.patch(`/api/v1/clients/${this.formClient.id}`, { cliente: data });
        this.changeRegionModal = false;
      } catch (error) {
        console.error("Erro ao salvar a região:", error);
      }
    },
    filterIsWithoutSafra() {
      if (!this.filter.anosafra.id && !this.filter.client) {
        this.$toasted.global.defaultError({ msg: "Escolha um ano safra!" });
        return;
      }
      this.loadFilteredClients();
    },
    findSalesmans(query) {
      this.filter.isLoadingSalesman = true;
      var data = {
        per_page: 10,
        q: { name: query, is_salesman: true },
      };

      if (this.filter.manager && this.filter.manager.id)
        data.q["manager_id"] = this.filter.manager.id;
      if (this.filter.manager && this.filter.manager.coordinated_id)
        data.q["manager_id"] = this.filter.manager.coordinated_id;
      if (this.filter.anosafra && this.filter.anosafra.id) {
        data.q["anosafra_id"] = this.filter.anosafra.id;
        data["anosafra_id"] = this.filter.anosafra.id;
      }

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.filter.isLoadingSalesman = false;
          this.filter.salesmans = response.data.users || [];
        })
        .catch(() => (this.filter.isLoadingSalesman = false));
    },
    async findWalletClient(salesmanId) {
      try {
        const response = await this.$http.secured.get(`/api/v1/users/${salesmanId}/wallet_client`);
        let salesmanClientsWallet = response.data || [];
        this.findSalesmanClients = salesmanClientsWallet.sort((a, b) => {
            const nameA = a.client_name || ""; 
            const nameB = b.client_name || ""; 

            if (nameA === "") return 1;
            if (nameB === "") return -1;

            return nameA.localeCompare(nameB);
        });
      } catch (error) {
        this.findSalesmanClients = null;
        console.error("Erro ao buscar clientes:", error);
        this.$toasted.global.defaultError({ msg: "Não possui clientes" });
      }
    },
    debouncedFindManagers(query) {
      if (this.findManagersTimeout) clearTimeout(this.findManagersTimeout);

      this.findManagersTimeout = setTimeout(
        () => this.findManagers(query),
        500
      );
    },
    findManagers(query) {
      this.filter.isLoadingManagers = true;
      var data = {
        per_page: 10,
        q: { name: query, is_manager: true, status: this.active },
      };

      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q["anosafra_id"] = this.filter.anosafra.id;

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.filter.isLoadingManagers = false;
          this.filter.managers = response.data.users || [];
        })
        .catch(() => (this.filter.isLoadingManagers = false));
    },
    loadRegions() {
      this.$http.secured
        .get("/api/v1/regions", {
          params: { 
            name_only: true,
            has_sector: true ,
            anosafra_id: this.filter.anosafra.id
          },
        })
        .then((response) => {
          this.regions = response.data;
        });
    },
    async loadSectors() {
      const response = await this.$http.secured.get("/api/v1/sectors", {
        params: {
          page: this.paginated_data,
        },
      });
      this.sectors = response.data;
    },
    findClients(query) {
      var data = {
        q: {},
        per_page: 10,
      };

      if (query.trim()) data.q.razao_social = query;

      if (this.filter.salesman && this.filter.salesman.id)
        data.q.salesman_id = this.filter.salesman.id;
      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q.anosafra_ids = this.filter.anosafra.id;

      this.filter.isLoadingClients = true;
      this.$http.secured
        .get("/api/v1/clients", { params: data })
        .then((response) => {
          this.filter.clients = response.data.clients;
          this.filter.isLoadingClients = false;
        })
        .catch(() => (this.filter.isLoadingClients = false));
    },
    loadFilteredClients() {
      var data = {
        per_page: this.paginated_data.per_page,
        page: this.paginated_data.current,
        grouped_by_region: true,
        q: {},
      };

      if (this.filter.manager && this.filter.manager.id)
        data.q.manager_ids = this.filter.manager.id;
      if (this.filter.manager && this.filter.manager.coordinated_id)
        data.q.manager_ids = this.filter.manager.coordinated_id;

      if (this.filter.status && this.filter.status.name)
      data.q.active_region = this.filter.status.value;

      if (this.filter.client && this.filter.client.id)
        data.q.id = this.filter.client.id;
      if (this.filter.salesman && this.filter.salesman.id)
        data.q.user_ids = this.filter.salesman.id;
      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q.anosafra_ids = this.filter.anosafra.id;

      this.isLoadingClients = true;
      this.$http.secured
        .get("/api/v1/clients", { params: data })
        .then((response) => {
          this.clients = response.data.clients;
          this.filteredClient = this.clients
          this.paginated_data.current = response.data.current;
          this.paginated_data.count = response.data.count;

          this.isLoadingClients = false;
        })
        .catch(() => (this.isLoadingClients = false));
    },
    clientsSearch(query, page = 1) {
      var data = {
        page: page,
        per_page: 10,
        q: {},
      };

      if (this.prevAnosafra) {
        data.prevAnosafra = true;
        if (this.formRegion) {
          data.prevRegion = this.formRegion.id;
        }
      }

      if (query.trim()) data.q.fulltext = query;

      this.filter.isLoadingClients = true;
      this.$http.secured
        .get("/api/v1/clients", { params: data })
        .then((response) => {
          this.clientPaginatedData = response.data;
          this.filter.isLoadingClients = false;
        })
        .catch(() => (this.filter.isLoadingClients = false));
    },
    timeoutableClientsSearch(page = 1) {
      const query = this.leftSearch;
      if (this.clientSearchTimeout) clearTimeout(this.clientSearchTimeout);

      this.clientSearchTimeout = setTimeout(this.clientsSearch(query, page), 500);
    },
    addRegion() {
      this.prevAnosafra = false;
      this.clientsSearch("");
      this.isCreating = true;
      this.formRegion = {};
      this.regionClients = [];
      this.findSalesmanClients = null;
      this.updateRegionClientsModal = true;
    },
    updateRegionClients(clients, region) {
      this.clientsSearch("");
      this.regionClients = clients;
      this.formRegion = region;
      this.isCreating = false;
      this.updateRegionClientsModal = true;
    },
    rmAllClients(clients) {
      var clientsWithGoals = clients.filter((client) => client.has_goals);
      const clientsWithoutGoals = clients.filter((client) => !client.has_goals);

      clientsWithoutGoals.forEach((client) => this.rmClient(client, true));

      if (clientsWithGoals.length > 0) {
        let clientsText = "";
        clientsText += clientsWithGoals
          .map((client) => client.name)
          .join(",");
        clientsText += "";

        swal.fire({
          title: `Alerta`,
          text: `As metas associadas aos seguintes clientes serão apagadas em conjunto com sua associação a essa carteira.${clientsText} Deseja continuar?`,
          buttonsStyling: false,
          icon: 'info',
          showCancelButton: true,
          cancelButtonClass: 'btn btn-warning',
          confirmButtonText: 'Continuar',
          confirmButtonClass: 'btn btn-success ml-2',
          cancelButtonText: "Cancelar",
          reverseButtons: true
        }).then((result)=>{
          if (result.isConfirmed) {
            clientsWithGoals.forEach((client) => this.rmClient(client, true));
          } else {
            clientsWithGoals.forEach((client) => {
              const position = clientsWithGoals.findIndex(
                (c) => c.id == client.id
              );
              this.regionClients.push(client);
            });
          }
        })
      }
    },
    async addClients(clients) {
      const data = clients.map((client) => { return {
        client_id: client.cliente,
        region_id: this.formRegion.id,
        anosafra_id: this.filter.anosafra.id
      }});

      this.$http.secured.post("/api/v1/client_regions/create_multiple", { client_regions: data })
        .then(console.log('Meta salva com sucesso', ))
        .catch((error) => {
          const position = this.regionClients.findIndex(
            (c) => c.id == client.id
          );
          this.regionClients.splice(position, 1);

          Object.values(error.response.data.errors).forEach((error_message) => {
            this.$toasted.global.defaultError({ msg: error_message });
          });
        });
    },
    getSalesmanRegion(salesman_id, client_id) {
      this.$http.secured.get("/api/v1/client_regions", {
        params: {
          q: {
            salesman_id: salesman_id,
            client_id: client_id
          },
          anosafra_id: this.filter.anosafra.id
        },
      })
      .then((response) => {
        const client_regions = response.data;
        if (client_regions == []) return

        client_regions.map((client_region) => {
          this.removeClienRegions(client_region.id)
        })
      })
      .catch((error) => {
        console.error('Error: get client_regions', error)
        this.$toasted.global.defaultError({msg: 'Erro ao remover carteira de clientes!'})
      });
    },
    removeClienRegions(clientRegionId) {
      const data = {
        id: clientRegionId
      }

      this.$http.secured.delete(`/api/v1/client_regions/${clientRegionId}`, data)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch((error) => {
          this.$toasted.global.defaultError({ msg: error.response.data.errors[0]})
        });
    },
    rmClient(client, skipVerification = false) {
      this.getSalesmanRegion(this.formSalesman.id, client.id)
      if (!skipVerification && client.has_goals) {
        swal
        .fire({
          title: `Deseja continuar?`,
          text: `As metas associadas ao cliente ${client.name} serão apagadas em conjunto com sua associação a essa carteira.`,
          buttonsStyling: false,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonClass: "btn btn-success mr-2",
          cancelButtonClass: "btn btn-default",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Continuar",
          icon: "warning",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.saveRegionClients(true);
            this.getSalesmanRegion(this.formSalesman.id, client.id)
          }
        });
      }
    },
    removeCulture(culture) {
      let lastCulture = this.formClient.lastCultureIds.find(lastCultureId => lastCultureId.culture_name === culture.description)
      lastCulture._destroy = true
      this.formClient.culture_ids_attributes.push(lastCulture)
    },
    formatClientProperties() {
      if (!this.formClient.client_properties[0]) return 
      this.formClient.client_properties_attributes = { 
        id: this.formClient.client_properties[0].id,
        area: this.formClient.area,
      }
    },
    initializeModal() {
      if (this.filter.anosafra) {
        this.selectAnosafraRegion(this.filter.anosafra);
      } else {
        this.regionName = '';
      }
    },
    selectAnosafraRegion(anosafra){
      this.regionName = ''
      if (!anosafra || !this.formRegion || !this.formRegion.anosafra_regions) return;

      this.selectedAnosafraRegion = this.formRegion.anosafra_regions.find((ar) => ar.anosafra_id == this.filter.anosafra.id) 
    },
    getRegionName(client) {
      let regionName = ''; 

      if (client.region && client.region.anosafra_regions && client.region.anosafra_regions.length > 0) {
        const matchingRegion = client.region.anosafra_regions.find(ar => ar.anosafra_id === this.filter.anosafra.id);
        
        if (matchingRegion) {
          regionName = matchingRegion.region_name;
        } else {
          regionName = client.region.name;
        }
      } else {
        regionName = client.region ? client.region.name : '';
      }

      return regionName;
    },
    async saveRegionClients(updateUserAssociations = false) {      
      try {
        await this.$http.secured
          .patch("/api/v1/regions/" + this.formRegion.id, {
            update_user_associations: updateUserAssociations,
            update_region_clients: true,
            anosafra_id: this.filter.anosafra.id,
            region: {
              anosafra_regions_attributes: [{
                id: this.selectedAnosafraRegion ? this.selectedAnosafraRegion.id : null,
                region_id: this.formRegion.id, region_name: this.nameInputValue,
                anosafra_id: this.filter.anosafra.id
              }],
              ...this.formRegion,
            }
          })
        
          this.updateRegionClientsModal = false;
          this.loadFilteredClients();
      } catch (error) {
        this.loadFilteredClients();
        if ( error.response.data && error.response.data.errors && error.response.data.errors.user_id) {
          this.showSalesmanAssociationError(
            error.response.data.errors.user_id
          )
        }
        if (error.response && error.response.data && error.response.data.errors) {
          Object.values(error.response.data.errors).forEach((error_message) => {
            this.$toasted.global.defaultError({ msg: error_message });
          });
        }
      }
    },
    showSalesmanAssociationError(message = "") {
      swal
        .fire({
          title: `Aviso!`,
          text: message,
          width: "650px",
          buttonsStyling: false,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonClass: "btn btn-warning",
          cancelButtonClass: "btn btn-default",
          cancelButtonText: "Escolher outro vendedor",
          confirmButtonText: "Remover vendedor da outra região",
          icon: "warning",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.saveRegionClients(true);
          }
        });
    },
    async getUser(id) {
      try {
        return await this.$http.secured.get(`/api/v1/users/${id}`);
      } catch (error) {
        console.log("error: ", error)
      }
    },
    async initRouteSalesman(salesmanId) {
      const response = await this.getUser(salesmanId)
      this.filter.salesman = response.data
      this.filterIsWithoutSafra()
    }
  },
  watch: {
    updateRegionClientsModal(newVal) {
      if (newVal) {
        this.initializeModal();
      }
    },
    "filter.manager": function () {
      if (this.$can("index", "user")) {
        this.filter.salesman = []
        this.findSalesmans("");
      }
      if (this.$can("index", "client")) {
        this.findClients("");
      }
    },
    "filter.anosafra": function (newVal) {
      if (this.$can("index", "user")) {
        this.findSalesmans("");
        this.findManagers("");
      }
      if (this.$can("index", "client")) {
        this.findClients("");
      }

      if (this.currentUser.is_admin) {
        this.findManagers("");
      }

      if (newVal) {
          this.selectAnosafraRegion(newVal);
      } else {
        this.regionName = '';
      }
    },
    prevAnosafra() {
      this.timeoutableClientsSearch();
    },
    formSalesman(newValue) {
      console.log("entrei no watch")
      if (!this.formSalesman || !this.formSalesman.id) return;

      this.findWalletClient(this.formSalesman.id)
      console.log("passei do método watch")
      this.formRegion.user_id = this.formSalesman.id;
    },
    // Updates the form based on the current selected region
    formRegion(newValue, oldValue) {
      if (this.prevAnosafra) {
        this.timeoutableClientsSearch();
      }

      const currentRequestId = Date.now();
      this.currentRequestId = currentRequestId;
      
      // Updating clients if region id changed
      let data = { q: { region_ids: newValue.id }, unpaged: true };

      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q.anosafra_ids = this.filter.anosafra.id;

      if (newValue.id != oldValue.id) {
        this.loadingRegionClients = true;
        this.$http.secured
          .get("/api/v1/clients/", {
            params: data,
          })
          .then((response) => {
            if (this.currentRequestId === currentRequestId) {
              this.regionClients = response.data;
              this.loadingRegionClients = false;
            }
          })
          .catch(() => {
            if (this.currentRequestId === currentRequestId) {
              this.regionClients = [];
              this.loadingRegionClients = false;
            }
          });
      }

      // Updating salesman if there is an user id and it changed
      if (!(newValue || newValue.user_id)) {
        this.formSalesman = {};
      } else if (oldValue.user_id != newValue.user_id) {
        this.loadingFormSalesman = true;
        this.$http.secured
          .get("/api/v1/users/" + newValue.user_id)
          .then((response) => {
            this.formSalesman = response.data;
            this.loadingFormSalesman = false;
          })
          .catch(() => {
            this.formSalesman = {};
            this.loadingFormSalesman = false;
            this.findSalesmanClients = null;
          });
      }
    },
    notificationAssociableId: function (newValue) {
      if (newValue) {
        this.initRouteSalesman(newValue);
        this.resetNotificationAction(); // Reset the state to avoid multiple triggers
      }
    }
  },
  mounted() {
    this.currentUser = this.$currentUser();

    if (this.$can("index", "user")) {
      this.findSalesmans("");
    }

    this.findClients("");
    this.loadRegions("");
    this.loadSectors("");

    if (this.$route.params.user_id || this.$route.params.empty_user) {
      if (this.$route.params.empty_user) this.openGoBackModal = true;

      this.initRouteSalesman(this.$route.params.user_id);
    } else if (this.currentUser.is_admin) {
      this.findManagers("");
    } else if (
      this.currentUser.is_manager ||
      this.currentUser.has_coordinateds
    ) {
      this.filter.managers = [this.currentUser];
      this.filter.salesmans = this.currentUser.salesmans;
      this.filter.manager = this.currentUser;
    } else if (this.currentUser.is_salesman) {
      this.filter.managers = [this.currentUser.manager];
      this.filter.salesmans = [this.currentUser];
      this.filter.manager = this.currentUser.manager;
      this.filter.salesman = this.currentUser;
    }
  },
  computed: {
    ...mapState({
      notificationAssociableId: state => state.notificationAssociableId
    }),
    disabledSave() {
      return this.formSalesman.salesman_type === 'balcao' || this.formSalesman.salesman_type === null
    },
     tooltipMessage() {
      if (this.formSalesman.salesman_type === 'balcao') {
        return "Operação não permitida: Vendedores classificados como 'Balcão' não podem ter carteiras de clientes atribuídas. Por favor, selecione outro tipo de vendedor para continuar.";
      } else if (this.formSalesman.salesman_type === null) {
        return "Operação não permitida: O tipo de vendedor não foi selecionado. Por favor, atribua um tipo ao vendedor para continuar.";
      }
      return "";
    },
    nameInputValue: {
      get() {
        if (this.regionName.length)       return this.regionName;
        if (!this.selectedAnosafraRegion) return this.formRegion.name;

        return this.selectedAnosafraRegion.region_name;
      },
      set(name) {
        this.regionName = name;
      }
    },
    formattedRegions() {
      return this.regions.map(region => ({
        id: region.id,
        regionName: region.anosafra_id === this.filter.anosafra.id ? region.region_name : region.name
      }));
    },
    sortedClientsBySeller() {
      if (!this.clients) return [];
      return this.clients.slice().sort((a, b) => {
        const nameA = (a.region && a.region.user && a.region.user.name) ? a.region.user.name.toLowerCase() : "";
        const nameB = (b.region && b.region.user && b.region.user.name) ? b.region.user.name.toLowerCase() : "";

        if (nameA === "") return 1;
        if (nameB === "") return -1;

        return nameA.localeCompare(nameB, 'pt-BR');
      });
    },
  },
};
</script>

<style>
.tab-pane {
  padding: 10px;
}
.list-picker-selected {
  background: #61cf8a !important;
}
.button-class {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
  margin-bottom: 10px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  min-width: 50% !important;
}

.button-class img {
  filter: invert(100%);
}

.list-picker-container {
  border-width: 10px !important;
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
  border-radius: 12px !important;
}

.list-picker-panel {
  border: 1px solid;
  border-color: #ccc;
  border-top: 3px solid;
  border-top-color: #61cf8a;
}

.tituloGrupos {
  background-color: #61cf8a !important;
  box-sizing: border-box !important;
  color: rgb(255, 255, 255) !important;
  display: inline-block !important;
  font-family: Roboto, sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  height: 30px !important;
  line-height: 17px !important;
  padding-bottom: 4px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 7px !important;
  text-align: left !important;
  text-size-adjust: 100% !important;
  visibility: visible !important;
  width: 100% !important;
  border-radius: 6px 6px 0px 0px;
  border-bottom: 0px !important;
}
.multiselect__placeholder {
  display: inline-block !important;
  margin-bottom: 10px !important;
  padding-top: 2px !important;
}

.multiselect__input,
.multiselect__single,
.multiselect__tag {
  display: inline-block !important;
  margin-bottom: 10px !important;
  padding-top: 2px !important;
  display: none;
}
.client-list {
  max-height: 400px;
  overflow-y: auto;
}

.client-height {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.client-list-item {
  border: 1px solid rgb(94, 218, 94);
  padding: 5px;
  margin: 5px 0;
  text-align: center;
  border-radius: 5px;
}

.left-padding-column .cell {
  padding-left: 12px !important;
}
</style>